// PL
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: "Właściwe organy",
    selectorLabel: "Proszę wybrać organ policyjny właściwy dla regionu",

    // Shared status fragments
    msgConnected: "Połączono.",
    msgValidated: "Zweryfikowano.",
    msgValidationError: "Błąd weryfikacji.",

    // SES Hospedajes
    sesSubtitle: "Sekretariat Stanu ds. Bezpieczeństwa · Ministerstwo Spraw Wewnętrznych",
    sesConnectedText: "Check-iny będą wysyłane automatycznie do SES Hospedajes.",
    sesVerifyCreds: "Proszę sprawdzić wprowadzone dane logowania.",
    sesNotConnected: "Nie podłączono jeszcze konta SES Hospedajes.",
    updateConnectedAccount: "Zaktualizuj podłączone konto",

    // Ertzaintza A19
    ertzSubtitle: "Policja regionalna Kraju Basków · rejestr podróżnych",
    ertzConnectedText: "Check-iny będą wysyłane automatycznie do Ertzaintza.",
    ertzVerifyCif: "Proszę sprawdzić CIF i kod obiektu.",
    ertzCredsSaved: 'Dane logowania zapisane. Proszę nacisnąć "Zweryfikuj połączenie", aby sprawdzić dostęp.',
    ertzCifLabel: "CIF obiektu",
    ertzCifPlaceholder: "np. B12345678",
    ertzCifHint: "Maks. 10 znaków. CIF wynajmującego zarejestrowany w Ertzaintza.",
    ertzCodeLabel: "Kod obiektu",
    ertzCodePlaceholder: "np. 01000001",
    ertzCodeHint: "Przydzielany przez Ertzaintza przy rejestracji obiektu.",
    envLabel: "Środowisko",
    envPre: "Przedprodukcyjne (testy)",
    envPro: "Produkcyjne",
    envHint: 'Środowiska "Przedprodukcyjne" należy użyć do weryfikacji przed włączeniem produkcji.',
    verifying: "Weryfikowanie...",
    verifyConnection: "Zweryfikuj połączenie",
    saving: "Zapisywanie...",
    updateCredentials: "Zaktualizuj dane logowania",
    saveAndConnect: "Zapisz i połącz",

    // Mossos d'Esquadra
    mossosSubtitle: "Generalitat de Catalunya · Registre de viatgers d'establiments d'hostalatge",

    // SIRE
    sireSubtitle: "System informacyjny rejestru cudzoziemców · Migración Colombia",
    sireConnectedText: "Check-iny będą wysyłane automatycznie.",
    sireRevisaCreds: "Proszę sprawdzić dane logowania.",
    docTypeLabel: "Typ dokumentu",
    selectTypePlaceholder: "Proszę wybrać typ",
    docNumberLabel: "Numer dokumentu",
    docNumberPlaceholder: "np. 123456789",
    passwordLabel: "Hasło",
    sirePasswordPlaceholder: "Hasło SIRE",
    showHideTitle: "Pokaż/ukryj",
    saveChanges: "Zapisz zmiany",

    // TRA
    traSubtitle: "Ministerstwo Handlu, Przemysłu i Turystyki · token autoryzacyjny",
    traReportsText: "Automatyczne raporty włączone.",
    traRevisaToken: "Proszę sprawdzić token/RNT.",
    traTokenLabel: "Token autoryzacyjny",
    traTokenPlaceholder: "Tutaj należy wkleić token wydany przez TRA",
    traCurrentToken: "Aktualny token: {token}",
    traNoTokenHint: "W razie braku tokenu PMS można go wygenerować pod adresem",
    traRntLabel: "RNT obiektu",
    traRntPlaceholder: "Tylko cyfry (np. 123456)",
    traRntHint: "Musi to być aktywny RNT obiektu (od 5 do 15 cyfr).",

    // Document types (Colombia)
    docTypeCitizenId: "Dowód obywatelski",
    docTypeForeignerId: "Karta pobytu cudzoziemca",

    // Alloggiati Web (residual placeholder)
    alloggiatiIdPlaceholder: "np. 1234",

    // Toasts / script messages
    needSaveListing: "Najpierw należy zapisać ofertę.",
    authChangedErtz: "Zmieniono organ na Ertzaintza (Kraj Basków).",
    authChangedMossos: "Zmieniono organ na Mossos d'Esquadra (Katalonia).",
    authChangedSes: "Zmieniono organ na SES Hospedajes.",
    authChangeError: "Nie udało się zmienić organu.",
    ertzSaved: "Dane logowania Ertzaintza zapisane.",
    saveGenericError: "Błąd podczas zapisywania.",
    ertzSaveError: "Błąd zapisu danych logowania Ertzaintza.",
    ertzTestOk: "Połączenie z Ertzaintza zweryfikowane pomyślnie.",
    testFailedCheck: "Weryfikacja nie powiodła się. Proszę sprawdzić dane.",
    ertzTestError: "Błąd weryfikacji połączenia z Ertzaintza.",
    mossosNeedCreds: "Proszę podać nazwę użytkownika i hasło do serwisu Mossos.",
    mossosFound: "Znaleziono {count} obiekt. Proszę wybrać swój. | Znaleziono {count} obiekty. Proszę wybrać swój. | Znaleziono {count} obiektów. Proszę wybrać swój.",
    mossosNoEstablishments: "Nie znaleziono obiektów na tym koncie.",
    mossosConnError: "Nie udało się połączyć z Mossos. Proszę sprawdzić nazwę użytkownika i hasło.",
    mossosNeedFields: "Proszę uzupełnić identyfikator policyjny i kod obiektu.",
    mossosSaved: "Dane logowania Mossos zapisane.",
    mossosSaveError: "Błąd zapisu danych logowania Mossos.",
    mossosTestOk: "Połączenie z Mossos zweryfikowane pomyślnie.",
    mossosTestError: "Błąd weryfikacji połączenia z Mossos.",
    mossosFileOk: "Plik wygenerowany. Należy go wgrać w serwisie Mossos (Fitxers massius).",
    mossosNoTravelers: "Brak podróżnych oczekujących na wysyłkę.",
    mossosConfigFirst: "Najpierw należy skonfigurować obiekt.",
    mossosFileError: "Nie udało się wygenerować pliku.",
    sireCompleteData: "Proszę uzupełnić wymagane dane do SIRE.",
    sireSaved: "SIRE zapisany pomyślnie.",
    sireSaveFailed: "Nie udało się zapisać SIRE.",
    sireSaveError: "Błąd podczas zapisywania SIRE.",
    sireDeactivated: "SIRE wyłączony.",
    sireActivated: "SIRE włączony.",
    sireStateFailed: "Nie udało się zmienić statusu SIRE.",
    sireStateError: "Błąd zmiany statusu SIRE.",
    traNeedToken: "Proszę podać token i prawidłowy RNT (tylko cyfry).",
    traSaved: "TRA zapisany pomyślnie.",
    traSaveFailed: "Nie udało się zapisać TRA.",
    traSaveError: "Błąd podczas zapisywania TRA.",
    traDeactivated: "TRA wyłączony.",
    traActivated: "TRA włączony.",
    traStateFailed: "Nie udało się zmienić statusu TRA.",
    traStateError: "Błąd zmiany statusu TRA.",
    stateChangeFailed: "Nie udało się zmienić statusu.",
    alloggiatiStateError: "Błąd zmiany statusu Alloggiati Web.",
    ross1000StateError: "Błąd zmiany statusu ROSS 1000.",
  },

  smartLocks: {
    loadingConfig: "Wczytywanie konfiguracji…",
    accessKeyTypeLabel: "Typ klucza dostępu",
    selectLockPlaceholder: "Proszę wybrać zamek",
    optionStatic: "Klucz statyczny",
    optionTtlock: "TTLock - zamek dynamiczny",
    optionTedee: "Tedee - zamek dynamiczny",
    optionShelly: "Shelly - inteligentny przekaźnik",
    optionYacan: "YACAN - inteligentny zamek",
    optionAkiles: "Akiles - Inteligentny zamek",
    optionOther: "Inna marka, spoza tej listy…",
    pillTedee: "Dostęp dynamiczny (Tedee)",
    pillTtlock: "Dostęp dynamiczny (TTLock)",
    pillShelly: "Zdalne otwieranie (Shelly)",
    pillYacan: "Zarządzany dostęp (YACAN)",
    pillAkiles: "Akiles połączony",
    pillStatic: "Dostęp statyczny",
    pillOther: "Prosimy o kontakt, pomożemy w integracji",
    disconnecting: "Odłączanie…",
    disconnect: "Odłącz",
    emptyTitle: "Podłącz inteligentny zamek",
    emptyText: "Proszę wybrać markę z listy powyżej, aby podłączyć zamek i automatycznie generować nowy klucz dla każdej rezerwacji.",
    emptyBrandOther: "Inne marki",
    unitFallback: "Jednostka {id}",
    staticModeInfo: "Wybrano tryb statyczny. Proszę wpisać klucz i nacisnąć Zapisz, aby go zastosować.",
    saveTypeError: "Nie udało się zapisać typu dostępu",
    disconnectSuccess: "Zamek odłączony",
    disconnectError: "Nie udało się odłączyć zamka.",
  },

  rates: {
    pageTitle: "Stawki",
    loading: "Wczytywanie stawek…",
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    singleUnit: "Pojedyncza jednostka",
    newBtn: "Nowa",
    colName: "Nazwa",
    colAdjustment: "Korekta",
    colFinal: "Cena końcowa",
    labelMain: "Główna",
    labelDerived: "Pochodna",
    base: "Bazowa",
    editTitle: "Edytuj",
    copyTitle: "Kopiuj do innej jednostki",
    deleteTitle: "Usuń",
    noDerived: "Brak stawek pochodnych dla tej taryfy.",
    emptyTitle: "Brak stawek głównych",
    emptyText: "Proszę utworzyć stawkę główną dla tej jednostki, a następnie będzie można tworzyć pochodne.",
    emptyCreate: "Utwórz pierwszą stawkę główną",
    globalEmptyTitle: "Nie wczytano żadnych jednostek",
    globalEmptyText: "Aby zarządzać stawkami, należy najpierw utworzyć pokoje lub jednostki.",
    editRate: "Edytuj stawkę",
    newRate: "Nowa stawka",
    fieldName: "Nazwa",
    namePlaceholder: "np. Stawka elastyczna",
    validityPeriod: "Okres obowiązywania",
    validityPermanent: "Stały",
    validityCustom: "Własny",
    validityHintCustom: "Opcjonalnie: obowiązuje tylko w tym zakresie",
    validityHintPermanent: "Stawka obowiązuje zawsze",
    startLabel: "Początek",
    endLabel: "Koniec",
    pricePerNight: "Cena za noc",
    taxIncluded: "Podatki wliczone",
    occupancy: "Obłożenie",
    guestsNumber: "Liczba gości",
    minStay: "Minimalny pobyt",
    maxStay: "Maksymalny pobyt",
    description: "Opis",
    optional: "Opcjonalne",
    rateplanBase: "Taryfa bazowa",
    selectRateplanBase: "Proszę wybrać taryfę bazową",
    rateplanBaseHint: "Proszę wybrać taryfę, na podstawie której będzie liczona ta stawka pochodna.",
    derivedNamePlaceholder: "np. Booking.com, Airbnb…",
    derivedNameHint: "Ta nazwa ułatwia rozpoznanie stawki przy mapowaniu OTA.",
    adjustmentType: "Typ korekty",
    percentage: "Procent",
    fixedAmount: "Kwota stała",
    adjustmentValue: "Wartość korekty",
    adjustmentValueHint: "(wartość ujemna oznacza rabat)",
    preview: "Podgląd",
    basePrice: "Cena bazowa",
    increment: "Podwyżka",
    discount: "Rabat",
    cancel: "Anuluj",
    saving: "Zapisywanie...",
    update: "Aktualizuj",
    create: "Utwórz",
    deleteModalTitle: "Usuń stawkę",
    deleteWarnStrong: "Tej operacji nie można cofnąć.",
    deleteWarnLead: "Do usunięcia:",
    deleteCascadeLabel: "Usuń też jej stawki pochodne ({count})",
    deleteCascadeHint: "Jeśli któraś stawka pochodna jest powiązana z OTA, usunięcie zostanie zablokowane.",
    deleteConfirmLabel: "Proszę wpisać dokładną nazwę, aby potwierdzić:",
    deleteConfirmPlaceholder: "Proszę wpisać nazwę dokładnie",
    deleteConfirmHint: "Chroni to przed przypadkowym usunięciem.",
    deleting: "Usuwanie...",
    deleteConfirmBtn: "Usuń trwale",
    copyModalTitle: "Kopiuj stawkę do innej jednostki",
    copyOrigin: "Źródło:",
    copyRate: "Stawka:",
    copyTargetUnit: "Jednostka docelowa",
    selectUnit: "Proszę wybrać jednostkę",
    copySameUnitHint: "Nie można kopiować do tej samej jednostki.",
    copyTargetBaseRate: "Docelowa stawka bazowa",
    selectMainRate: "Proszę wybrać stawkę główną",
    copyDerivedHint: "Ta stawka pochodna zostanie powiązana z tamtą stawką główną w jednostce docelowej.",
    copyNoMainRates: "Jednostka docelowa nie ma stawek głównych. Najpierw należy utworzyć lub skopiować główną.",
    copyNewNameLabel: "Nazwa w miejscu docelowym",
    copyRenameHint: "Można ją zmienić, aby uniknąć duplikatów.",
    copyCascadeLabel: "Skopiuj też stawki pochodne ({count})",
    copyCascadeHint: "Powstaną nowe stawki pochodne wskazujące na skopiowaną taryfę główną.",
    copying: "Kopiowanie...",
    copyBtn: "Kopiuj",

    // Toasts / script messages
    loadError: "Błąd wczytywania stawek",
    rangeErrorSelect: "Należy wybrać prawidłowy zakres dat",
    rangeErrorStartEnd: "Data początkowa nie może być późniejsza niż data końcowa",
    rangeErrorMinStay: "Minimalny pobyt to {minStay} nocy, a wybrany zakres ma {nights} nocy",
    invalidUnit: "Nieprawidłowa jednostka",
    completeRequired: "Proszę uzupełnić wymagane pola",
    updated: "Zaktualizowano",
    created: "Utworzono",
    saveError: "Błąd podczas zapisywania",
    deleted: "Usunięto",
    deleteLinkedOta: "Nie można usunąć: stawka jest powiązana z OTA.",
    deleteGenericError: "Błąd podczas usuwania",
    deleteDerivedError: "Nie udało się usunąć stawki pochodnej",
    copied: "Skopiowano",
    copyGenericError: "Błąd podczas kopiowania",
    invalidTargetUnit: "Nieprawidłowa jednostka docelowa",
    selectTargetBaseError: "Proszę wybrać docelową stawkę bazową, aby powiązać stawkę pochodną.",
    invalidTargetBaseError: "Wybrana docelowa stawka bazowa nie jest prawidłowa dla jednostki docelowej.",
    defaultRateName: "Stawka",
    defaultDerivedName: "Pochodna",
    copySuffix: "(Kopia)",
  },
};
